<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${resellerService.name}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="resellerService" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "reseller-service-view-logs",

  components: { LogListTable },

  props: ["resellerService"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
